const env = process.env;

export const AppName = env.REACT_APP__APP_NAME;
export const INPUT_FILE_MAX_SIZE = env.REACT_APP__INPUT_FILE_MAX_SIZE;
export const EVENT_INPUT_MAX_LEN = parseInt(env.REACT_APP__EVENT_INPUT_MAX_LEN);
export const DEF_APP_THEME = env.REACT_APP__DEF_APP_THEME || 'Orchid';

//--------------Backend-Frontend common fields start-------------------------------
export const Modules = {
    Home: "Home",//same as Dashboard
    Dashboard: "Dashboard",
    UserProfile: "My Account",

    //Allocation-based modules
    WebMeeting: "Web Meeting",
    DiscussionForum: "Discussion Forum",
    Survey: "Survey",
    Resources: "Resources",
    PeerProfiles: "Peer Profiles",
    Messages: "Messages",
    Meetings: "Meetings",
    MyParticipations: "My Participations",
    Search: "Search",
    RecommendPeer: "Recommend Peer",
    RecommendActivity: "Recommend Activity",
    News: "News",
    RecentResources: "Recent Resources",
    Publication: "Publication",
    Documents: "Documents",
    CaseStudy: "Case Study",
    Videos: "Videos",
    Images: "Images",
    UsefulLinks: "Useful Links",

    ProfileDetails: "Profile Details",
    Help: "Help",
    Share: "Share",
    TermsOfUse: "Terms of Use",
    Legal: "Legal Notice",

    Login: "Sign In",
    RequestAccess: "Request Access",
    ForgotPw: "Forgot Password",

    Company: "Company",//Company & subdomain are basically the same
    Test: "Test",
    LoginBypass: "Login Bypass",
    EventAlerts: "Event Alerts",

    Survey_ViewQs: "View Survey Questions and Answers",
    Survey_EditQs: "Create Survey Questions and Answers",
    AllModules: "All Modules",
    AllocatedModules: "Allocated Modules",
};

export const ModuleRouteUrls = {
    [Modules.Home]: '/',
    [Modules.Dashboard]: '/', // [Modules.Home]: '/',
    // [Modules.Dashboard]: '/',
    [Modules.UserProfile]: '/myaccount',
    [Modules.Publication]: '/publication',
    [Modules.PeerProfiles]: '/profile',
    [Modules.Messages]: '/message',
    [Modules.Meetings]: '/meeting',
    [Modules.WebMeeting]: '/web-meeting',
    [Modules.Documents]: '/documents',
    [Modules.DiscussionForum]: '/forum',
    [Modules.Survey]: '/survey',
    [Modules.CaseStudy]: '/case-study',
    [Modules.Resources]: '/resources',
    [Modules.Videos]: '/videos',
    [Modules.Images]: '/images',
    [Modules.UsefulLinks]: '/useful-links',
    [Modules.RecentResources]: '/recent-resources',
    [Modules.RecommendActivity]: '/create-activity',
    [Modules.MyParticipations]: '/my-participations',
    [Modules.Help]: '/help',
    [Modules.Test]: '/test',
    [Modules.TermsOfUse]: '/terms-of-use',
    [Modules.Legal]: '/legal',
    [Modules.Search]: '/search',
};

export const GenRouteUrls = {
    login: '/login',
    requestAccess: '/request_access',
    forgotPw: '/forgot-password',
    _404: '*',

    //meeting-route-urls
    meeting_uploadPage: '/create-meeting',
    meeting_recomPage: '/create-rmeeting',
    meeting_internalPage: '/meeting-details?id=',
    meeting_editPage: '/edit-meeting?id=',

    //res-route-urls
    res_recomPage: '/create-rresource1',//https://speak.kolsandpeers.com/vok/create-rresource1.php?cid=publications

    //cs-route-urls
    cs_uploadPage: '/create-casestudy',
    cs_recomPage: '/create-rcasestudies',
    cs_internalPage: '/casestudy-details?id=',
    cs_editPage: '/edit-casestudy?id=',

    //link-route-urls
    link_uploadPage: '/create-usefullinks',
    link_recomPage: '/create-rusefullinks',
    link_internalPage: '/usefullink-details?id=',
    link_editPage: '/edit-usefullink?id=',

    //recom-route-urls
    recom_uploadPage: '/create-peer',
    recom_PeerPage: '/create-rpeer',
    recom_internalPage: '/peer-details?id=',
    recom_editPage: '/edit-peer?id=',
    recom_activity: '/create-activity',

    //pub-route-urls
    pub_uploadPage: '/create-publication',
    pub_recomPage: '/create-rpublication',
    pub_internalPage: '/publication-details?id=',
    pub_editPage: '/edit-publication?id=',

    //doc-route-urls
    doc_uploadPage: '/create-documents',
    doc_recomPage: '/create-rdocuments',
    doc_internalPage: '/document-details?id=',
    doc_editPage: '/edit-documents?id=',

    //wm-route-urls
    wm_uploadPage: '/create-webmeeting',
    wm_recomPage: '/create-rwebmeeting',
    wm_internalPage: '/webmeeting-details?id=',
    wm_editPage: '/edit-webmeeting?id=',

    //forum-route-urls
    df_uploadPage: '/create-forum',
    df_recomPage: '/create-rforum',
    df_internalPage: '/forum-details?id=',
    df_editPage: '/edit-forum?id=',

    //img-route-urls
    img_uploadPage: '/create-images',
    img_createAlbumPage: '/create-album',
    img_recomPage: '/create-rimages',
    img_editPage: '/edit-images?id=',
    imgAlbum_editPage: '/edit-album?id=',

    //vid-route-urls
    vid_uploadPage: '/create-videos',
    vid_createFolder: '/create-folder',
    vid_recomPage: '/create-rvideos',
    vid_editPage: '/edit-videos?id=',

    //survey-route-urls
    survey_uploadPage: '/create-survey',
    survey_recomPage: '/create-rsurvey',
    survey_internalPage: '/survey-details?id=',
    survey_editPage: '/edit-survey?id=',
    survey_viewSurveyPage: '/view-survey?id=',
    survey_viewQsPage: '/view-survey-questions?id=',
    survey_createQsPage: '/create-survey-question?sid=',
    survey_editQsPage: '/edit-survey-question?id=',

// recommend news route
    news_recommendNewsForm: '/r-news',

    //peer-profile
    pp_internalPage: '/profile-details?id=',

    //message
    msg_internalPage: '/msg-detail?id=',

    //various

};

export const ReqUrls = {
    //auth
    login: '/user-login',
    checkSessionExpired: '/check-session-expired',
    logout: '/logout',
    checkLoginAvailable: '/check-login-available',
    requestAccess: '/request-access',
    forgotPw: '/forgot-password',
    fetchDiscForumPageData: '/fetch-disc-forum-page-data',
    searchPage__fetchMatchedData: '/search-page-fetch-matched-data',
    recentRes__mainPage_fetch_recordList: '/recent-res-main-page-fetch-record-list',
    perms_fetchAllocatedModules: '/perms-fetch-allocated-modules',

    //various
    fetchSubdomainDataFromAdminDb: '/fetched-subdomain-data',
    eventForm__fetch_participantsList: '/event-form-fetch-participants-list',
    testRequest: '/test-request',
    fetchUserRecord: '/fetch-user-record',
    updateUserRecord: '/update-user-record',
    resetUserPassword: '/reset-user-password',

    //wm
    wm__mainPage_fetch_recordList: '/wm-main-page-fetch-record-list',
    wm__mainPage_delete_record: '/wm-main-page-delete-record',
    wm__addEditPage_submit_formData: '/wm-add-edit-page-submit-form-data',
    wm__addEditPage_fetch_editFormData: '/wm-add-edit-page-fetch-edit-form-data',

    //survey
    survey__mainPage_fetch_recordList: '/survey-main-page-fetch-record-list',
    survey__mainPage_delete_record: '/survey-main-page-delete-record',
    survey__mainPage_view_survey: '/survey-main-page-view-survey',
    survey__mainPage_download_survey_pdf: '/survey-main-page-download-survey-pdf',
    survey__viewSurveyPage_submitQsResponses: '/survey-view-survey-page-submit-qs-responses',
    survey__mainPage_add_survey_qs: '/survey-main-page-add-survey-qs',
    survey__addEditPage_submit_formData: '/survey-add-edit-page-submit-form-data',
    survey__addEditPage_fetch_editFormData: '/survey-add-edit-page-fetch-edit-form-data',
    survey__viewQsPage_fetch_SurveyQs: '/survey-view-qs-page-fetch-survey-qs',
    survey__viewQsPage_delete_Q: '/survey-view-qs-page-delete-q',
    survey__addEditQsPage_fetch_editFormData: '/survey-add-edit-qs-page-fetch-edit-form-data',
    survey__addEditQsPage_submit_formData: '/survey-add-edit-qs-page-submit-form-data',

    //meeting
    meeting__mainPage_fetch_recordList: '/meeting-main-page-fetch-record-list',
    meeting__mainPage_delete_record: '/meeting-main-page-delete-record',
    meeting__addEditPage_submit_formData: '/meeting-add-edit-page-submit-form-data',
    meeting__addEditPage_fetch_editFormData: '/meeting-add-edit-page-fetch-edit-form-data',

    //pub
    pub__mainPage_fetch_recordList: '/pub-main-page-fetch-record-list',
    pub__mainPage_delete_record: '/pub-main-page-delete-record',
    pub__addEditPage_submit_formData: '/pub-add-edit-page-submit-form-data',
    pub__addEditPage_fetch_editFormData: '/pub-add-edit-page-fetch-edit-form-data',

    //doc
    doc__mainPage_fetch_recordList: '/doc-main-page-fetch-record-list',
    doc__mainPage_delete_record: '/doc-main-page-delete-record',
    doc__addEditPage_submit_formData: '/doc-add-edit-page-submit-form-data',
    doc__addEditPage_fetch_editFormData: '/doc-add-edit-page-fetch-edit-form-data',
    doc__createFolder_submitFormData: '/doc-create-folder-submit-form-data',
    doc__fetch_Folders: '/doc-fetch-folders',

    //cs
    cs__mainPage_fetch_recordList: '/cs-main-page-fetch-record-list',
    cs__mainPage_delete_record: '/cs-main-page-delete-record',
    cs__addEditPage_submit_formData: '/cs-add-edit-page-submit-form-data',
    cs__addEditPage_fetch_editFormData: '/cs-add-edit-page-fetch-edit-form-data',

    //link
    link__mainPage_fetch_recordList: '/link-main-page-fetch-record-list',
    link__mainPage_delete_record: '/link-main-page-delete-record',
    link__addEditPage_submit_formData: '/link-add-edit-page-submit-form-data',
    link__addEditPage_fetch_editFormData: '/link-add-edit-page-fetch-edit-form-data',

    //vid
    vid__mainPage_fetch_recordList: '/vid-main-page-fetch-record-list',
    vid__mainPage_delete_record: '/vid-main-page-delete-record',
    vid__addEditPage_submit_formData: '/vid-add-edit-page-submit-form-data',
    vid__addEditPage_fetch_editFormData: '/vid-add-edit-page-fetch-edit-form-data',

    //img
    img__mainPage_fetch_recordList: '/img-main-page-fetch-record-list',
    img__mainPage_delete_record: '/img-main-page-delete-record',
    img__addEditPage_submit_formData: '/img-add-edit-page-submit-form-data',
    img__recomPage_submit_formData: '/img-recom-page-submit-form-data',
    img__addEditPage_fetch_editFormData: '/img-add-edit-page-fetch-edit-form-data',
    img__addEditAlbum_submitFormData: '/img-add-edit-album-submit-form-data',
    img__fetch_Albums: '/img-fetch-albums',
    img__album_addEditPage_fetch_editFormData: '/img-album-add-edit-fetch-form-data',

    //df
    df__mainPage_fetch_recordList: '/df-main-page-fetch-record-list',
    df__mainPage_delete_record: '/df-main-page-delete-record',
    df__addEditPage_submit_formData: '/df-add-edit-page-submit-form-data',
    df__addEditPage_fetch_editFormData: '/df-add-edit-page-fetch-edit-form-data',
    df__internalPage_subUnsubNotifs: '/df-internal-page-sub-unsub-notifs',
    df__internalPage_submitComment: '/df-internal-page-submit-comment',

    //msgs
    msg__mainPage_fetch_recordList: '/msg-main-page-fetch-record-list',
    msg__mainPage_createMsg: '/msg-main-page-create-msg',
    msg__internalPage_fetchData: '/msg-internal-page-fetch-data',

    //pp
    pp__mainPage_fetch_recordList: '/pp-main-page-fetch-record-list',
    pp__internalPage_fetchData: '/pp-internal-page-fetch-data',

    //various
    peer__recomForm_submit_formData: '/peer-recom-form-submit-form-data',
    news__recomForm_submit_formData: '/news-recom-form-submit-form-data',
    activity__recomForm_submit_formData: '/activity-recom-form-submit-form-data',
    news__addEditPage_submit_formData: '/news-add-edit-page-submit-form-data',
    dashCalendar__fetchEvents: '/dash-calendar-fetch-events',
    dashRecentPanel__fetchData: '/dash-recent-panel-fetch-data',
    fetchCompanyMembersList: '/fetch-company-members-list',
    helpPage__submitHelpForm: '/help-page-submit-help-form',

    //bypass-token
    loginBypass_verifyToken: '/login-bypass-verify-token',
    loginBypass_updateTokenUsedCount: '/login-bypass-update-token-used-count',
    loginBypass_enableDisableToken: '/login-bypass-enable-disable-token',
    loginBypass_deleteToken: '/login-bypass-delete-token',
    loginBypass_updateToken: '/login-bypass-update-token',
    loginBypass_insertSharePageLinks: '/login-bypass-insert-share-page-links',
    loginBypass_guestUser_fetchShareLink: '/login-bypass-guest-user-fetch-share-link',
    loginBypass_guestUser_updateShareLink: '/login-bypass-guest-user-update-share-link',

    //reminder-alert
    eventReminderAlert_fetchEventData: '/event-reminder-alert-fetch-event-data',
    eventReminderAlert_submitAlertData: '/event-reminder-alert-submit-alert-data',

};

export const Keys = {
    theme: 'theme',
    themeValues: 'themeValues',
    browserUrl: 'browserUrl',
    appTheme: 'appTheme',

    //session keys
    sessionData: 'u$3r$3$$!0nd@t@',
    lsSessionSuperKey: '1$$3$$!0n$up3rk3y',
    lastUrlToRemember: '!@$tur1t0r3m3mb3r',
    sessionToken: 'tk3n',
    isBypassSessionRunning: 'isBypassSessionRunning',
    loginExpired: 'loginExpired',
    tokenNotFound: 'tokenNotFound',
    memberId: 'memberId',
    loginPageImg: 'olgienApge',
    reqPageImg: 'arcalongmi',
    authUsername: 'ulersecuregem',
    authPw: 'gemulerkey',
    loginWithPinEnabled: 'enpoessame',

    //url-params
    urlParam_loginBypassTokenAlias: 'vac',//vok access-code
    urlParam_loginUsername: 'vun',
    urlParam_loginPw: 'vup',
    urlParam_Tab: 'tab', // authcode
    urlParam_SearchQuery: 'q',
    urlParam_SearchTypeId: 'qid',
    urlParam_SearchTargetId: 'tfid',
    // accesscode
    // passkey

    //store-keys
    // storeType_Local: 'storeType_Local',
    // storeType_Simple: 'storeType_Simple',
    storeType_Session: 'storeType_Session',
    store_Dash_WebMeetingModuleTabData: 'store_Dash_WebMeetingModuleTabData',
    store_Dash_ForumModuleTabData: 'store_Dash_ForumModuleTabData',
    store_Dash_SurveyModuleTabData: 'store_Dash_SurveyModuleTabData',
    store_Dash_ResourceModuleTabData: 'store_Dash_ResourceModuleTabData',
    store_Dash_HomeTab_TabLayout_SelectedTabIndex: 'store_Dash_HomeTab_TabLayout_SelectedTabIndex',
    store_Dash_HomeTab_TabLayout_SelectedTabName: 'store_Dash_HomeTab_TabLayout_SelectedTabName',
    store_Dash_HomeTab_TabLayout_RecResTabData: 'store_Dash_HomeTab_TabLayout_RecResTabData',
    store_Dash_HomeTab_TabLayout_PubTabData: 'store_Dash_HomeTab_TabLayout_PubTabData',
    store_Dash_HomeTab_TabLayout_DocTabData: 'store_Dash_HomeTab_TabLayout_DocTabData',
    store_Dash_HomeTab_TabLayout_CsTabData: 'store_Dash_HomeTab_TabLayout_CsTabData',
    store_Dash_HomeTab_TabLayout_VideoTabData: 'store_Dash_HomeTab_TabLayout_VideoTabData',
    store_Dash_HomeTab_TabLayout_ImgTabData: 'store_Dash_HomeTab_TabLayout_ImgTabData',
    store_Dash_HomeTab_TabLayout_LinkTabData: 'store_Dash_HomeTab_TabLayout_LinkTabData',
    store_Dash_HomeTab_ShowVokMsgBox: 'store_Dash_HomeTab_ShowVokMsgBox',
    store_Dash_HomeTab_searchInputDropdownName: 'store_Dash_HomeTab_searchInputDropdownName',
    store_Dash_HomeTab_searchInputDropdownId: 'store_Dash_HomeTab_searchInputDropdownId',
    store_Dash_HomeTab_searchTargetId: 'store_Dash_HomeTab_searchTargetId',
    store_Dash_HomeTab_searchTargetName: 'store_Dash_HomeTab_searchTargetName',

    //subdomain keys
    subdomainData: 'subdomaindata',
    subdomain_Name: 'company_subdomain',
    subdomain_CompanyName: 'company_name',
    subdomain_Logo: 'company_logo',
    subdomainPrefs: 'domain_prefs',
    subdomain_DescriptionImg: 'welcome_image',
    subdomain_Description: 'welcome_msg',
    subdomain_LoginImage: 'login_img',
    subdomain_RequestAccessImage: 'reqacs_img',
    // subdomain_ShowAuthPageImage: 'sdShowAuthPageImage',

    //config
    config_showHelp: 'config_showHelp',
    config_showShare: 'config_showShare',
    config_ShowTabBar: 'config_ShowTabBar',
    config_TabBarTab: 'config_TabBarTab',
    config_showSearch: 'config_showSearch',
    config_showRecentPanel: 'config_showRecentPanel',
    config_showCalendar: 'config_showCalendar',
    config_showHomeRightPanels: 'config_showHomeRightPanels',
    config_showNavBar: 'config_showNavBar',
    config_showFooter: 'config_showFooter',
    config_navbarCurrPage: 'config_navbarCurrPage',

    tracker_currPageTag: 'tracker_currPageTag',
    tracker_currPageModule: 'tracker_currPageModule',

    sharePanel_recordTitle: 'sharePanel_recordTitle',
    sharePanel_recordDescription: 'sharePanel_recordDescription',
};

export const ModuleFieldsData = {
    [Modules.UserProfile]: {
        //table-columns: member_id, company_id, member_prefix, first_name, last_name, user_name, user_password, vok_user_password, member_user, member_dob, gender, member_email1, member_email2, work_phone1, work_phone2, member_mobile1, member_mobile2, home_phone, member_speciality1, member_speciality2, member_image, country_id, state_id, city_id, member_timezone, member_organisation1, member_designation1, member_organisation2, member_designation2, highest_education, interest_area1, interest_area2, member_biography, work_address1, work_address2, home_address, member_remark, you_have, access_internet, send_reminder, con_time, other_time, con_day, other_day, accept_policy, member_status, insert_date, insert_by, update_date, update_by, `timestamp`, member_online, login_time, logout_time, total_login, new_total_login
        memberId: {
            column: "member_id",
            title: "Member Id",
            field: "memberId",
        },
        companyId: {
            column: "company_id",
            title: "Company Id",
            field: "companyId",
        },
        memberPrefix: {
            column: "member_prefix",
            title: "Member Prefix",
            field: "memberPrefix",
        },
        firstName: {
            column: "first_name",
            title: "First Name",
            field: "firstName",
        },
        lastName: {
            column: "last_name",
            title: "Last Name",
            field: "lastName",
        },
        fullName: {
            column: "fullName",
            title: "Full Name",
            field: "fullName",
        },
        username: {
            column: "user_name",
            title: "Username",
            field: "username",
        },
        userPassword: {
            column: "user_password",
            title: "User Password",
            field: "userPassword",
        },
        vokUserPassword: {
            column: "vok_user_password",
            title: "Vok User Password",
            field: "vokUserPassword",
        },
        loginPin: {
            column: "login_pin",
            title: "Login PIN",
        },
        memberUser: {
            column: "member_user",
            title: "Member User",
            field: "memberUser",
        },
        memberDob: {
            column: "member_dob",
            title: "Member Dob",
            field: "memberDob",
        },
        gender: {
            column: "gender",
            title: "Gender",
            field: "gender",
        },
        memberEmail1: {
            column: "member_email1",
            title: "Member Email 1",
            field: "memberEmail1",
        },
        memberEmail2: {
            column: "member_email2",
            title: "Member Email 2",
            field: "memberEmail2",
        },
        workPhone1: {
            column: "work_phone1",
            title: "Work Phone 1",
            field: "workPhone1",
        },
        workPhone2: {
            column: "work_phone2",
            title: "Work Phone 2",
            field: "workPhone2",
        },
        memberMobile1: {
            column: "member_mobile1",
            title: "Member Mobile 1",
            field: "memberMobile1",
        },
        memberMobile2: {
            column: "member_mobile2",
            title: "Member Mobile 2",
            field: "memberMobile2",
        },
        homePhone: {
            column: "home_phone",
            title: "Home Phone",
            field: "homePhone",
        },
        memberSpeciality1: {
            column: "member_speciality1",
            title: "Member Speciality 1",
            titleAlt: "Specialization",
            field: "memberSpeciality1",
        },
        memberSpeciality2: {
            column: "member_speciality2",
            title: "Member Speciality 2",
            field: "memberSpeciality2",
        },
        memberImage: {
            column: "member_image",
            title: "Member Image",
            field: "memberImage",
        },
        countryId: {
            column: "country_id",
            title: "Country Id",
            field: "countryId",
        },
        stateId: {
            column: "state_id",
            title: "State Id",
            field: "stateId",
        },
        cityId: {
            column: "city_id",
            title: "City Id",
            field: "cityId",
        },
        countryName: {
            column: "country_name",
            title: "Country",
        },
        stateName: {
            column: "state_name",
            title: "State",
        },
        cityName: {
            column: "city_name",
            title: "City",
        },
        memberTimezone: {
            column: "member_timezone",
            title: "Member Timezone",
            field: "memberTimezone",
        },
        memberOrganisation1: {
            column: "member_organisation1",
            title: "Member Organisation 1",
            field: "memberOrganisation1",
        },
        memberDesignation1: {
            column: "member_designation1",
            title: "Member Designation 1",
            field: "memberDesignation1",
        },
        memberOrganisation2: {
            column: "member_organisation2",
            title: "Member Organisation 2",
            field: "memberOrganisation2",
        },
        memberDesignation2: {
            column: "member_designation2",
            title: "Member Designation 2",
            field: "memberDesignation2",
        },
        highestEducation: {
            column: "highest_education",
            title: "Highest Education",
            field: "highestEducation",
        },
        interestArea1: {
            column: "interest_area1",
            title: "Interest Area 1",
            field: "interestArea1",
        },
        interestArea2: {
            column: "interest_area2",
            title: "Interest Area 2",
            field: "interestArea2",
        },
        memberBiography: {
            column: "member_biography",
            title: "Member Biography",
            titleAlt: "Bio",
            field: "memberBiography",
        },
        workAddress1: {
            column: "work_address1",
            title: "Work Address 1",
            field: "workAddress1",
        },
        workAddress2: {
            column: "work_address2",
            title: "Work Address 2",
            field: "workAddress2",
        },
        homeAddress: {
            column: "home_address",
            title: "Home Address",
            field: "homeAddress",
        },
        memberRemark: {
            column: "member_remark",
            title: "Member Remark",
            field: "memberRemark",
        },
        youHave: {
            column: "you_have",
            title: "You Have",
            field: "youHave",
        },
        accessInternet: {
            column: "access_internet",
            title: "Access Internet",
            field: "accessInternet",
        },
        sendReminder: {
            column: "send_reminder",
            title: "Send Reminder",
            field: "sendReminder",
        },
        conTime: {
            column: "con_time",
            title: "Con Time",
            field: "conTime",
        },
        otherTime: {
            column: "other_time",
            title: "Other Time",
            field: "otherTime",
        },
        conDay: {
            column: "con_day",
            title: "Con Day",
            field: "conDay",
        },
        otherDay: {
            column: "other_day",
            title: "Other Day",
            field: "otherDay",
        },
        acceptPolicy: {
            column: "accept_policy",
            title: "Accept Policy",
            field: "acceptPolicy",
        },
        memberStatus: {
            column: "member_status",
            title: "Member Status",
            field: "memberStatus",
        },
        insertDate: {
            column: "insert_date",
            title: "Insert Date",
            field: "insertDate",
        },
        insertBy: {
            column: "insert_by",
            title: "Insert By",
            field: "insertBy",
        },
        updateDate: {
            column: "update_date",
            title: "Update Date",
            field: "updateDate",
        },
        updateBy: {
            column: "update_by",
            title: "Update By",
            field: "updateBy",
        },
        timestamp: {
            column: "timestamp",
            title: "Timestamp",
            field: "timestamp",
        },
        memberOnline: {
            column: "member_online",
            title: "Member Online",
            field: "memberOnline",
        },
        loginTime: {
            column: "login_time",
            title: "Login Time",
            field: "loginTime",
        },
        logoutTime: {
            column: "logout_time",
            title: "Logout Time",
            field: "logoutTime",
        },
        totalLogin: {
            column: "total_login",
            title: "Total Login",
            field: "totalLogin",
        },
        newTotalLogin: {
            column: "new_total_login",
            title: "New Total Login",
            field: "newTotalLogin"
        },
        imageExt: {
            column: "imageExt",
            title: "imageExt",
            field: "imageExt"
        },
        allocatedModules: {
            column: "allocatedModules",
            title: "allocatedModules",
            field: "allocatedModules"
        },
    },
    [Modules.Company]: {
        //table-columns (BACKEND_DB-tblcompany): company_id, pcompany_id, company_name, company_email, company_phone, company_logo, brand_logo, footer_logo, project_name, country_id, state_id, city_id, company_address, company_website, timezone_id, company_remark, get_help, cperson_name1, cperson_designation1, cperson_phone1, cperson_mobile1, cperson_email1, cperson_name2, cperson_designation2, cperson_phone2, cperson_mobile2, cperson_email2, cperson_name3, cperson_designation3, cperson_phone3, cperson_mobile3, cperson_email3, manager_name, manager_phone, manager_email, content_peers, content_medical, case_study, survey, expert_speak, imp_updates, articles, upload_document, create_forum, forum_validate, company_subdomain, company_subdomain_access, welcome_image, welcome_msg, imp_update, legal_notice, privacy_policy, help_header, help_bottom, company_status, insert_date, insert_by, update_date, update_by, domain_url, domain_prefs, login_img, reqacs_img
        companyId: {
            column: "company_id",
            title: "Company Id",
            field: "companyId"
        },
        parentCompanyId: {
            column: "pcompany_id",
            title: "Parent company Id",
            field: "pCompanyId"
        },
        companyName: {
            column: "company_name",
            title: "Company Name",
            field: "companyName"
        },
        companyEmail: {
            column: "company_email",
            title: "Company Email",
            field: "companyEmail"
        },
        companyPhone: {
            column: "company_phone",
            title: "Company Phone",
            field: "companyPhone"
        },
        companyLogo: {
            column: "company_logo",
            title: "Company Logo",
            field: "companyLogo"
        },
        brandLogo: {
            column: "brand_logo",
            title: "Brand Logo",
            field: "brandLogo"
        },
        footerLogo: {
            column: "footer_logo",
            title: "Footer Logo",
            field: "footerLogo"
        },
        projectName: {
            column: "project_name",
            title: "Project Name",
            field: "projectName"
        },
        countryId: {
            column: "country_id",
            title: "Country Id",
            field: "countryId"
        },
        stateId: {
            column: "state_id",
            title: "State Id",
            field: "stateId"
        },
        cityId: {
            column: "city_id",
            title: "City Id",
            field: "cityId"
        },
        companyAddress: {
            column: "company_address",
            title: "Company Address",
            field: "companyAddress"
        },
        companyWebsite: {
            column: "company_website",
            title: "Company Website",
            field: "companyWebsite"
        },
        timezoneId: {
            column: "timezone_id",
            title: "Timezone Id",
            field: "timezoneId"
        },
        companyRemark: {
            column: "company_remark",
            title: "Company Remark",
            field: "companyRemark"
        },
        getHelp: {
            column: "get_help",
            title: "Get Help",
            field: "getHelp"
        },
        contactPersonName1: {
            column: "cperson_name 1",
            title: "Contact Person Name 1",
            field: "cPersonName1"
        },
        contactPersonDesignation1: {
            column: "cperson_designation 1",
            title: "Contact Person Designation 1",
            field: "cpersonDesignation1"
        },
        contactPersonPhone1: {
            column: "cperson_phone 1",
            title: "Contact Person Phone 1",
            field: "cpersonPhone1"
        },
        contactPersonMobile1: {
            column: "cperson_mobile 1",
            title: "Contact Person Mobile 1",
            field: "cpersonMobile1"
        },
        contactPersonEmail1: {
            column: "cperson_email 1",
            title: "Contact Person Email 1",
            field: "cpersonEmail1"
        },
        contactPersonName2: {
            column: "cperson_name 2",
            title: "Contact Person Name 2",
            field: "cpersonName2"
        },
        contactPersonDesignation2: {
            column: "cperson_designation 2",
            title: "Contact Person Designation 2",
            field: "cpersonDesignation2"
        },
        contactPersonPhone2: {
            column: "cperson_phone 2",
            title: "Contact Person Phone 2",
            field: "cpersonPhone2"
        },
        contactPersonMobile2: {
            column: "cperson_mobile 2",
            title: "Contact Person Mobile 2",
            field: "cpersonMobile2"
        },
        contactPersonEmail2: {
            column: "cperson_email 2",
            title: "Contact Person Email 2",
            field: "cpersonEmail2"
        },
        contactPersonName3: {
            column: "cperson_name 3",
            title: "Contact Person Name 3",
            field: "cpersonName3"
        },
        contactPersonDesignation3: {
            column: "cperson_designation 3",
            title: "Contact Person Designation 3",
            field: "cpersonDesignation3"
        },
        contactPersonPhone3: {
            column: "cperson_phone 3",
            title: "Contact Person Phone 3",
            field: "cpersonPhone3"
        },
        contactPersonMobile3: {
            column: "cperson_mobile 3",
            title: "Contact Person Mobile 3",
            field: "cpersonMobile3"
        },
        contactPersonEmail3: {
            column: "cperson_email 3",
            title: "Contact Person Email 3",
            field: "cpersonEmail3"
        },
        managerName: {
            column: "manager_name",
            title: "Manager Name",
            field: "managerName"
        },
        managerPhone: {
            column: "manager_phone",
            title: "Manager Phone",
            field: "managerPhone"
        },
        managerEmail: {
            column: "manager_email",
            title: "Manager Email",
            field: "managerEmail"
        },
        contentPeers: {
            column: "content_peers",
            title: "Content Peers",
            field: "contentPeers"
        },
        contentMedical: {
            column: "content_medical",
            title: "Content Medical",
            field: "contentMedical"
        },
        caseStudy: {
            column: "case_study",
            title: "Case Study",
            field: "caseStudy"
        },
        survey: {
            column: "survey",
            title: "",
            field: "survey"
        },
        expertSpeak: {
            column: "expert_speak",
            title: "Expert Speak",
            field: "expertSpeak"
        },
        impUpdates: {
            column: "imp_updates",
            title: "Imp Updates",
            field: "impUpdates"
        },
        articles: {
            column: "articles",
            title: "Articles",
            field: "articles"
        },
        uploadDocument: {
            column: "upload_document",
            title: "Upload Document",
            field: "uploadDocument"
        },
        createForum: {
            column: "create_forum",
            title: "Create Forum",
            field: "createForum"
        },
        forumValidate: {
            column: "forum_validate",
            title: "Forum Validate",
            field: "forumValidate"
        },
        companySubdomain: {
            column: "company_subdomain",
            title: "Company Subdomain",
            field: "companySubdomain"
        },
        companySubdomainAccess: {
            column: "company_subdomain_access",
            title: "Company Subdomain Access",
            field: "companySubdomainAccess"
        },
        welcomeImage: {
            column: "welcome_image",
            title: "Welcome Image",
            field: "welcomeImage"
        },
        welcomeMsg: {
            column: "welcome_msg",
            title: "Welcome Msg",
            field: "welcomeMsg"
        },
        impUpdate: {
            column: "imp_update",
            title: "Imp Update",
            field: "impUpdate"
        },
        legalNotice: {
            column: "legal_notice",
            title: "Legal Notice",
            field: "legalNotice"
        },
        privacyPolicy: {
            column: "privacy_policy",
            title: "Privacy Policy",
            field: "privacyPolicy"
        },
        helpHeader: {
            column: "help_header",
            title: "Help Header",
            field: "helpHeader"
        },
        helpBottom: {
            column: "help_bottom",
            title: "Help Bottom",
            field: "helpBottom"
        },
        companyStatus: {
            column: "company_status",
            title: "Company Status",
            field: "companyStatus"
        },
        insertDate: {
            column: "insert_date",
            title: "Insert Date",
            field: "insertDate"
        },
        insertBy: {
            column: "insert_by",
            title: "Insert By",
            field: "insertBy"
        },
        updateDate: {
            column: "update_date",
            title: "Update Date",
            field: "updateDate"
        },
        updateBy: {
            column: "update_by",
            title: "Update By",
            field: "updateBy"
        },
        domainUrl: {
            column: "domain_url",
            title: "Domain Url",
            field: "domainUrl"
        },
        domainPrefs: {
            column: "domain_prefs",
            title: "Domain Prefs",
            field: "domainPrefs"
        },
        loginImg: {
            column: "login_img",
            title: "Login Image",
            field: "loginImg"
        },
        reqacsImg: {
            column: "reqacs_img",
            title: "Request Access Image",
            field: "requestAccessImg"
        }
    },

    [Modules.Meetings]: {
        recordId: {
            column: "meeting_id",
            title: "recordId"
        },
        companyId: {
            column: "company_id",
            title: "Company Id"
        },
        memberId: {
            column: "member_id",
            title: "Member Id"
        },
        title: {
            column: "meeting_title",
            title: "Title",
            titleAlt: "Meeting Topic",
        },
        outline: {
            column: "meeting_outline",
            title: "Outline",
        },
        desc: {
            column: "meeting_desc",
            title: "Description",
            titleAlt: "Meeting Description",
        },
        venue: {
            column: "meeting_venue",
            title: "Venue",
            titleAlt: "Meeting Venue",
            titleAlt2: "Meeting Venue (Address or google map link for meeting venue)",
        },
        date: {
            column: "meeting_date",
            title: "Date",
            titleAlt: "Meeting Schedule",
            titleAlt2: "Select Date & Time (Your Timezone)",
        },
        ampm: {
            column: "meeting_ampm",
            title: "Ampm"
        },
        duration: {
            column: "meeting_duration",
            title: "Duration"
        },
        timezone: {
            column: "meeting_tzone",
            title: "Timezone"
        },
        type: {
            column: "meeting_type",
            title: "Meeting Type",
        },
        memberType: {
            column: "member_type",
            title: "Member Type"
        },
        presenter: {
            column: "meeting_pname",
            title: "Presenter Name",
            titleAlt: "Presenter"
        },
        newPresenterQualification: {
            column: "meeting_pqualif",
            title: "Qualification"
        },
        newPresenterDesignation: {
            column: "meeting_pdesig",
            title: "Designation",
            titleAlt: "Presenter Position"
        },
        newPresenterOrg: {
            column: "meeting_porg",
            title: "Organization",
            titleAlt: "Company"
        },
        newPresenterBio: {
            column: "meeting_pbio",
            title: "Bio",
            titleAlt: "Presenter's Bio"
        },
        newPresenterImage: {
            column: "meeting_pimage",
            title: "Presenter Image"
        },
        participants: {
            column: "meeting_participants",
            title: "Participants"
        },
        participantDisplayType: {
            column: "participantDisplayType",
            title: "participantDisplayType"
        },
        participantNames: {
            column: "meeting_participants",
            title: "Participants"
        },
        participantNamesSelectedOnly: {
            column: "participantNamesSelectedOnly",
            title: "Participants"
        },
        participantGroupNames: {
            column: "participantGroupNames",
            title: "participantGroupNames"
        },
        doc: {
            column: "meeting_doc",
            title: "Related documents & files",
            titleAlt: "Related document"
        },
        docFileExt: {
            column: "docFileExt",
            title: "docFileExt"
        },
        docDesc: {
            column: "meeting_docdesc",
            title: "Uploaded file description"
        },
        repeat: {
            column: "meeting_repeat",
            title: "Repeat"
        },
        repeatAmPm: {
            column: "repeat_ampm",
            title: "Repeat AM/PM"
        },
        repeatDate: {
            column: "repeat_date",
            title: "Repeat Date"
        },
        reminders: {
            column: "reminders",
            title: "Reminders",
            titleAlt: "Reminder Frequency"
        },
        reminder_doNotEmail: {
            column: "donot_email",
            title: "Do not send Email"
        },
        reminder_doNotSms: {
            column: "donot_sms",
            title: "Do not SMS"
        },
        reminder_eventEmail: {
            column: "event_email",
            title: "Event Email"
        },
        reminder_eventSms: {
            column: "event_sms",
            title: "Event SMS"
        },
        reminder_day15Email: {
            column: "day15_email",
            title: "Day 15 Email"
        },
        reminder_day15Sms: {
            column: "day15_sms",
            title: "Day 15 SMS"
        },
        reminder_day7Email: {
            column: "day7_email",
            title: "Day 7 Email"
        },
        reminder_day7Sms: {
            column: "day7_sms",
            title: "Day 7 SMS"
        },
        reminder_day3Email: {
            column: "day3_email",
            title: "Day 3 Email"
        },
        reminder_day3Sms: {
            column: "day3_sms",
            title: "Day 3 SMS"
        },
        reminder_day1Email: {
            column: "day1_email",
            title: "Day 1 Email"
        },
        reminder_day1Sms: {
            column: "day1_sms",
            title: "Day 1 SMS"
        },
        reminder_samedayEmail: {
            column: "sameday_email",
            title: "Same day Email"
        },
        reminder_samedaySms: {
            column: "sameday_sms",
            title: "Sameday SMS"
        },
        reminder_hrs3Email: {
            column: "hrs3_email",
            title: "Hrs 3 Email"
        },
        reminder_hrs3Sms: {
            column: "hrs3_sms",
            title: "Hrs 3 SMS"
        },
        reminder_hrs1Email: {
            column: "hrs1_email",
            title: "Hrs 1 Email"
        },
        reminder_hrs1Sms: {
            column: "hrs1_sms",
            title: "Hrs 1 SMS"
        },
        reminder_min15Email: {
            column: "min15_email",
            title: "Min 15 Email"
        },
        reminder_min15Sms: {
            column: "min15_sms",
            title: "Min 15 SMS"
        },
        summary: {
            column: "meeting_summery",
            title: "Summary"
        },
        status: {
            column: "meeting_status",
            title: "Status"
        },
        insertDate: {
            column: "insert_date",
            title: "Insert Date"
        },
        insertBy: {
            column: "insert_by",
            title: "Insert By"
        },
        updateDate: {
            column: "update_date",
            title: "Update Date"
        },
        updateBy: {
            column: "update_by",
            title: "Update By"
        },
        pid: {
            column: "meeting_pid",
            title: "Pid"
        },
        rImage: {
            column: "meeting_rpimage",
            title: "R Image"
        },
        rDoc: {
            column: "meeting_rdoc",
            title: "Rdoc"
        },
        rDocFileExt: {
            column: "rDocFileExt",
            title: "rDocFileExt"
        },
        rSummary: {
            column: "meeting_rsummery",
            title: "Summary"
        }

    },
    [Modules.WebMeeting]: {
        //main-page clms: recordId, presenter, outline, date
        //add/edit-page clms: webmeeting_id, company_id, member_id, webmeeting_date, webmeeting_ampm, webmeeting_duration, webmeeting_tzone, webmeeting_title, webmeeting_outline, webmeeting_desc, webmeeting_link, webex_image, member_type, webmeeting_pname, webmeeting_pqualif, webmeeting_pdesig, webmeeting_porg, webmeeting_pbio, webmeeting_pimage, webmeeting_participants, webmeeting_doc, webmeeting_docdesc, webmeeting_repeat, repeat_ampm, repeat_date, donot_email, donot_sms, event_email, event_sms, day15_email, day15_sms, day7_email, day7_sms, day3_email, day3_sms, day1_email, day1_sms, sameday_email, sameday_sms, hrs3_email, hrs3_sms, hrs1_email, hrs1_sms, min15_email, min15_sms, webmeeting_summery, webmeeting_status, insert_date, insert_by, update_date, update_by, webmeeting_pid, webex_rimage, webmeeting_rpimage, webmeeting_rdoc, webmeeting_rsummery
        recordId: {
            column: "webmeeting_id",
            title: "webmeeting_id"
        },
        title: {
            column: "webmeeting_title",
            title: "Meeting Title",
            titleAlt: "title",
            titleAlt2: "Web Meeting Topic"
        },
        presenter: {
            column: "webmeeting_pname",
            title: "Presenter Name",
            titleAlt: "Presenter"
        },
        outline: {
            column: "webmeeting_outline",
            title: "Meeting Outline",
            titleAlt: "Outline",
            titleAlt2: "Discussion Outline",
        },
        date: {
            column: "webmeeting_date",
            title: "Select Date & Time* (Your Timezone)",
            titleAlt: "Date",
            titleAlt2: "Meeting Schedule",
        },
        companyId: {
            column: "company_id",
            title: "Company Id"
        },
        memberId: {
            column: "member_id",
            title: "Member Id"
        },
        ampm: {
            column: "webmeeting_ampm",
            title: "AM/PM"
        },
        duration: {
            column: "webmeeting_duration",
            title: "Duration"
        },
        timezone: {
            column: "webmeeting_tzone",
            title: "Time Zone Sensitive"
        },
        desc: {
            column: "webmeeting_desc",
            title: "Meeting Description",
            titleAlt: "Discussion Description",
            titleAlt2: "Description",
        },
        link: {
            column: "webmeeting_link", // title: "Meeting Webex Link",
            title: "Meeting Link",//from sir, 8Apr2024
            titleAlt: "Link"
        },
        webexImage: {
            column: "webex_image", // title: "Webex Image",
            title: "Meeting Image",//from sir, 8Apr2024
        },
        memberType: {
            column: "member_type",
            title: "Member Type"
        },
        newPresenterQualification: {
            column: "webmeeting_pqualif",
            title: "Qualification"
        },
        newPresenterDesignation: {
            column: "webmeeting_pdesig",
            title: "Designation",
            titleAlt: "Presenter Position",
        },
        newPresenterOrg: {
            column: "webmeeting_porg",
            title: "Organization",
            titleAlt: "Company",
        },
        newPresenterBio: {
            column: "webmeeting_pbio",
            title: "Bio",
            titleAlt: "Presenter's Bio",
        },
        newPresenterImage: {
            column: "webmeeting_pimage",
            title: "Presenter Image"
        },
        participants: {
            column: "webmeeting_participants",
            title: "Participants"
        },
        participantDisplayType: {
            column: "participantDisplayType",
            title: "participantDisplayType"
        },
        participantNames: {
            column: "webmeeting_participants",
            title: "Participants"
        },
        participantNamesSelectedOnly: {
            column: "participantNamesSelectedOnly",
            title: "Participants"
        },
        participantGroupNames: {
            column: "participantGroupNames",
            title: "participantGroupNames"
        },
        doc: {
            column: "webmeeting_doc",
            title: "Related documents & files",
            titleAlt: "Related document"
        },
        docFileExt: {
            column: "docFileExt",
            title: "docFileExt",
        },
        docDesc: {
            column: "webmeeting_docdesc",
            title: "Uploaded file description"
        },
        repeat: {
            column: "webmeeting_repeat",
            title: "Repeat"
        },
        repeatAmPm: {
            column: "repeat_ampm",
            title: "Repeat AM/PM"
        },
        repeatDate: {
            column: "repeat_date",
            title: "Repeat Date"
        },
        reminders: {
            column: "reminders",
            title: "Reminders",
            titleAlt: "Reminder Frequency",
        },
        reminder_doNotEmail: {
            column: "donot_email",
            title: "Do not send Email"
        },
        reminder_doNotSms: {
            column: "donot_sms",
            title: "Do not SMS"
        },
        reminder_eventEmail: {
            column: "event_email",
            title: "Event Email"
        },
        reminder_eventSms: {
            column: "event_sms",
            title: "Event SMS"
        },
        reminder_day15Email: {
            column: "day15_email",
            title: "Day 15 Email"
        },
        reminder_day15Sms: {
            column: "day15_sms",
            title: "Day 15 SMS"
        },
        reminder_day7Email: {
            column: "day7_email",
            title: "Day 7 Email"
        },
        reminder_day7Sms: {
            column: "day7_sms",
            title: "Day 7 SMS"
        },
        reminder_day3Email: {
            column: "day3_email",
            title: "Day 3 Email"
        },
        reminder_day3Sms: {
            column: "day3_sms",
            title: "Day 3 SMS"
        },
        reminder_day1Email: {
            column: "day1_email",
            title: "Day 1 Email"
        },
        reminder_day1Sms: {
            column: "day1_sms",
            title: "Day 1 SMS"
        },
        reminder_samedayEmail: {
            column: "sameday_email",
            title: "Same day Email"
        },
        reminder_samedaySms: {
            column: "sameday_sms",
            title: "Sameday SMS"
        },
        reminder_hrs3Email: {
            column: "hrs3_email",
            title: "Hrs 3 Email"
        },
        reminder_hrs3Sms: {
            column: "hrs3_sms",
            title: "Hrs 3 SMS"
        },
        reminder_hrs1Email: {
            column: "hrs1_email",
            title: "Hrs 1 Email"
        },
        reminder_hrs1Sms: {
            column: "hrs1_sms",
            title: "Hrs 1 SMS"
        },
        reminder_min15Email: {
            column: "min15_email",
            title: "Min 15 Email"
        },
        reminder_min15Sms: {
            column: "min15_sms",
            title: "Min 15 SMS"
        },
        summary: {
            column: "webmeeting_summery",
            title: "Summary"
        },
        status: {
            column: "webmeeting_status",
            title: "Status"
        },
        insertDate: {
            column: "insert_date",
            title: "Insert Date"
        },
        insertBy: {
            column: "insert_by",
            title: "Insert By"
        },
        updateDate: {
            column: "update_date",
            title: "Update Date"
        },
        updateBy: {
            column: "update_by",
            title: "Update By"
        },
        pid: {
            column: "webmeeting_pid",
            title: "Pid"
        },
        webexRImage: {
            column: "webex_rimage",
            title: "Webex R Image"
        },
        rImage: {
            column: "webmeeting_rpimage",
            title: "R Image"
        },
        rDoc: {
            column: "webmeeting_rdoc",
            title: "Rdoc"
        },
        rDocFileExt: {
            column: "rDocFileExt",
            title: "rDocFileExt",
        },
        rSummary: {
            column: "webmeeting_rsummery",
            title: "Summary"
        },

    },
    [Modules.DiscussionForum]: {
        recordId: {
            column: "forum_id",
            title: "recordId",
        },
        memberId: {
            column: "member_id",
            title: "Member Id"
        },
        companyId: {
            column: "company_id",
            title: "Company Id"
        },
        title: {
            column: "forum_topic",
            title: "Title",
            titleAlt: "Forum Topic",
        },
        desc: {
            column: "forum_description",
            title: "Description",
            titleAlt: "Forum Description",
            titleAlt2: "Introduction",
        },
        docFileExt: {
            column: "docFileExt",
            title: "docFileExt",
        },
        startDate: {
            column: "forum_startdate",
            title: "Start date",
            titleAlt: "Forum start date (Your Timezone)",
        },
        endDate: {
            column: "forum_enddate",
            title: "Forum end date",
            titleAlt: "Forum open till",
            titleAlt2: "Open till",
        },
        startDateAmPm: {
            column: "forum_startampm",
            title: "Forum Start Am Pm"
        },
        endDateAmPm: {
            column: "forum_endampm",
            title: "Forum End Am Pm"
        },
        timezone: {
            column: "forum_tzone",
            title: "Timezone Sensitive"
        },
        leader: {
            column: "forum_leader",
            title: "Forum Leader",
            // titleAlt: "Discussion led by",
            titleAlt: "Discussion Chair",
        },
        participants: {
            column: "participants",
            title: "Participants (Only the names selected here will see and join this forum in there respective login.)"
        },
        participantDisplayType: {
            column: "participantDisplayType",
            title: "participantDisplayType"
        },
        participantNames: {
            column: "forum_participants",
            title: "Participants"
        },
        participantNamesSelectedOnly: {
            column: "participantNamesSelectedOnly",
            title: "Participants"
        },
        participantGroupNames: {
            column: "participantGroupNames",
            title: "participantGroupNames"
        },
        doc: {
            column: "forum_doc",
            title: "Related documents & files",
            titleAlt: "Related document"
        },
        docDesc: {
            column: "forum_docdesc",
            title: "Uploaded file description"
        },
        reminders: {
            column: "reminders",
            title: "Reminders",
            titleAlt: "Reminder Frequency",
        },
        reminder_doNotEmail: {
            column: "donot_email",
            title: "Do not send Email"
        },
        reminder_doNotSms: {
            column: "donot_sms",
            title: "Do not SMS"
        },
        reminder_eventEmail: {
            column: "event_email",
            title: "Event Email"
        },
        reminder_eventSms: {
            column: "event_sms",
            title: "Event SMS"
        },
        reminder_day15Email: {
            column: "day15_email",
            title: "Day 15 Email"
        },
        reminder_day15Sms: {
            column: "day15_sms",
            title: "Day 15 SMS"
        },
        reminder_day7Email: {
            column: "day7_email",
            title: "Day 7 Email"
        },
        reminder_day7Sms: {
            column: "day7_sms",
            title: "Day 7 SMS"
        },
        reminder_day3Email: {
            column: "day3_email",
            title: "Day 3 Email"
        },
        reminder_day3Sms: {
            column: "day3_sms",
            title: "Day 3 SMS"
        },
        reminder_day1Email: {
            column: "day1_email",
            title: "Day 1 Email"
        },
        reminder_day1Sms: {
            column: "day1_sms",
            title: "Day 1 SMS"
        },
        reminder_samedayEmail: {
            column: "sameday_email",
            title: "Same day Email"
        },
        reminder_samedaySms: {
            column: "sameday_sms",
            title: "Sameday SMS"
        },
        reminder_hrs3Email: {
            column: "hrs3_email",
            title: "Hrs 3 Email"
        },
        reminder_hrs3Sms: {
            column: "hrs3_sms",
            title: "Hrs 3 SMS"
        },
        reminder_hrs1Email: {
            column: "hrs1_email",
            title: "Hrs 1 Email"
        },
        reminder_hrs1Sms: {
            column: "hrs1_sms",
            title: "Hrs 1 SMS"
        },
        reminder_min15Email: {
            column: "min15_email",
            title: "Min 15 Email"
        },
        reminder_min15Sms: {
            column: "min15_sms",
            title: "Min 15 SMS"
        },
        summery: {
            column: "forum_summery",
            title: "Summery"
        },
        status: {
            column: "forum_status",
            title: "Forum Status"
        },
        insertDate: {
            column: "insert_date",
            title: "Insert Date"
        },
        insertBy: {
            column: "insert_by",
            title: "Insert By"
        },
        updateDate: {
            column: "update_date",
            title: "Update Date"
        },
        updateBy: {
            column: "update_by",
            title: "Update By"
        },
        rDoc: {
            column: "forum_rdoc",
            title: "Forum Rdoc"
        },
        rSummery: {
            column: "forum_rsummery",
            title: "Forum Rsummery"
        },

        commentList: {
            column: 'commentList',
            title: 'Comment List'
        },
        totalViews: {
            column: "total_views",
            title: "Total Views"
        },
        myComment: {
            column: "my_comment_count",//Depends on the JOIN at db_handler.df__mainPage_fetch_recordList
            title: "My Comments",
        },
        comments: {
            column: "comment_count",//Depends on the JOIN at db_handler.df__mainPage_fetch_recordList
            title: "All Comments",
        },

        comment_recordId: {
            column: 'freplyp_id',
            title: 'recordId'
        },
        comment_forumId: {
            column: 'forum_id',
            title: 'Forum Id'
        },
        comment_memberId: {
            column: 'member_id',
            title: 'Member Id'
        },
        comment_memberName: {
            column: 'member_name',//Depends on the JOIN at db_handler.df__addEditPage_fetch_editFormData.getComments
            title: 'Member Name'
        },
        comment_commentText: {
            column: 'comments',
            title: 'Comments'
        },
        comment_replyPrivate: {
            column: 'reply_private',
            title: 'Reply Private'
        },
        comment_status: {
            column: 'freplyp_status',
            title: 'Freplyp Status'
        },
        comment_insertDate: {
            column: 'insert_date',
            title: 'Insert Date'
        },
        comment_insertBy: {
            column: 'insert_by',
            title: 'Insert By'
        },
        comment_replyList: {
            column: 'comment_replyList',
            title: 'Replies'
        },

        commentReply_recordId: {
            column: 'freplyc_id',
            title: 'recordId'
        },
        commentReply_forumId: {
            column: 'forum_id',
            title: 'Forum Id'
        },
        commentReply_replyId: {
            column: 'freplyp_id',
            title: 'Freplyp Id'
        },
        commentReply_memberId: {
            column: 'member_id',
            title: 'Member Id'
        },
        commentReply_memberName: {
            column: 'reply_member_name',//Depends on the JOIN at db_handler.df__addEditPage_fetch_editFormData.getComments
            title: 'Member Name'
        },
        commentReply_commentText: {
            column: 'comments',
            title: 'Comments'
        },
        commentReply_replyPrivate: {
            column: 'reply_private',
            title: 'Reply Private'
        },
        commentReply_status: {
            column: 'freplyc_status',
            title: 'Freplyc Status'
        },
        commentReply_insertDate: {
            column: 'insert_date',
            title: 'Insert Date'
        },
        commentReply_insertBy: {
            column: 'insert_by',
            title: 'Insert By'
        }
    },
    [Modules.Survey]: {
        recordId: {
            column: "survey_id",
            title: "recordId",
        },
        companyId: {
            column: "company_id",
            title: "Company Id"
        },
        memberId: {
            column: "member_id",
            title: "Member Id"
        },
        title: {
            column: "survey_topic",
            title: "Topic",
            titleAlt: "Survey Topic",
        },
        desc: {
            column: "survey_description",
            title: "Topic description",
            titleAlt: "Survey Description",
        },
        introduction: {
            column: "survey_introduction",
            title: "Introduction",
            titleAlt: "Survey Introduction",
        },
        timezone: {
            column: "survey_tzone",
            title: "Timezone"
        },
        link: {
            column: "survey_link",
            title: "Link",
            titleAlt: "External survey link",
        },
        startDate: {
            column: "survey_startdate",
            title: "Start date",
            titleAlt: "Survey start date* (Your Timezone)",
        },
        startDateAmPm: {
            column: "survey_startampm",
            title: "Startampm"
        },
        endDate: {
            column: "survey_enddate",
            title: "Survey open till",
            titleAlt: "Survey end date",
        },
        endDateAmPm: {
            column: "survey_endampm",
            title: "Endampm"
        },
        participants: {
            column: "participants",
            title: "Participants"
        },
        participantDisplayType: {
            column: "participantDisplayType",
            title: "participantDisplayType"
        },
        participantNames: {
            column: "survey_participants",
            title: "Participants"
        },
        participantNamesSelectedOnly: {
            column: "participantNamesSelectedOnly",
            title: "Participants"
        },
        participantGroupNames: {
            column: "participantGroupNames",
            title: "participantGroupNames"
        },
        doc: {
            column: "survey_doc",
            title: "Related documents & files",
            titleAlt: "Related document"
        },
        docFileExt: {
            column: "docFileExt",
            title: "docFileExt",
        },
        docDesc: {
            column: "survey_docdesc",
            title: "Uploaded file description"
        },
        reminders: {
            column: "reminders",
            title: "Reminders",
            titleAlt: "Reminder Frequency",
        },
        reminder_doNotEmail: {
            column: "donot_email",
            title: "Do not send Email"
        },
        reminder_doNotSms: {
            column: "donot_sms",
            title: "Do not SMS"
        },
        reminder_eventEmail: {
            column: "event_email",
            title: "Event Email"
        },
        reminder_eventSms: {
            column: "event_sms",
            title: "Event SMS"
        },
        reminder_day15Email: {
            column: "day15_email",
            title: "Day 15 Email"
        },
        reminder_day15Sms: {
            column: "day15_sms",
            title: "Day 15 SMS"
        },
        reminder_day7Email: {
            column: "day7_email",
            title: "Day 7 Email"
        },
        reminder_day7Sms: {
            column: "day7_sms",
            title: "Day 7 SMS"
        },
        reminder_day3Email: {
            column: "day3_email",
            title: "Day 3 Email"
        },
        reminder_day3Sms: {
            column: "day3_sms",
            title: "Day 3 SMS"
        },
        reminder_day1Email: {
            column: "day1_email",
            title: "Day 1 Email"
        },
        reminder_day1Sms: {
            column: "day1_sms",
            title: "Day 1 SMS"
        },
        reminder_samedayEmail: {
            column: "sameday_email",
            title: "Same day Email"
        },
        reminder_samedaySms: {
            column: "sameday_sms",
            title: "Sameday SMS"
        },
        reminder_hrs3Email: {
            column: "hrs3_email",
            title: "Hrs 3 Email"
        },
        reminder_hrs3Sms: {
            column: "hrs3_sms",
            title: "Hrs 3 SMS"
        },
        reminder_hrs1Email: {
            column: "hrs1_email",
            title: "Hrs 1 Email"
        },
        reminder_hrs1Sms: {
            column: "hrs1_sms",
            title: "Hrs 1 SMS"
        },
        reminder_min15Email: {
            column: "min15_email",
            title: "Min 15 Email"
        },
        reminder_min15Sms: {
            column: "min15_sms",
            title: "Min 15 SMS"
        },
        summery: {
            column: "survey_summery",
            title: "Summery"
        },
        status: {
            column: "survey_status",
            title: "Status"
        },
        insertDate: {
            column: "insert_date",
            title: "Insert Date"
        },
        insertBy: {
            column: "insert_by",
            title: "Insert By"
        },
        updateDate: {
            column: "update_date",
            title: "Update Date"
        },
        updateBy: {
            column: "update_by",
            title: "Update By"
        },
        rDoc: {
            column: "survey_rdoc",
            title: "Rdoc"
        },
        rSummery: {
            column: "survey_rsummery",
            title: "Rsummery"
        },
        type: {
            column: "survey_type",
            title: "Survey Type"
        }
    },

    [Modules.Publication]: {
        recordId: {
            column: "publication_id",
            title: "recordId"
        },
        companyId: {
            column: "company_id",
            title: "Company Id"
        },
        memberId: {
            column: "member_id",
            title: "Member Id"
        },
        memberUser: {
            column: "member_user",
            title: "Member User"
        },
        title: {
            column: "publication_title",
            title: "Title",
            titleAlt: "Publication Title",
        },
        author: {
            column: "publication_author",
            title: "Author(s)",
            titleAlt: "Author",
        },
        docFileExt: {
            column: "docFileExt",
            title: "docFileExt",
        },
        desc: {
            column: "publication_desc",
            title: "Description",
            titleAlt: "Publication Abstract or Uploaded File Description",
        },
        date: {
            column: "publication_date",
            title: "Date",
            titleAlt: "Publication Date",
        },
        refLink: {
            column: "publication_url",
            title: "Link",
            titleAlt: "Url",
            titleAlt2: 'Reference',
            titleAlt3: 'Publication Link',
        },
        file: {
            column: "publication_file",
            title: "File"
        },
        notificationTo: {
            column: "notification_to",
            title: "Send notification to"
        },
        participantDisplayType: {
            column: "participantDisplayType",
            title: "participantDisplayType"
        },
        participantNames: {
            column: "participants",
            title: "participants"
        },
        participantNamesSelectedOnly: {
            column: "participantNamesSelectedOnly",
            title: "Notification receivers"
        },
        participantGroupNames: {
            column: "participantGroupNames",
            title: "participantGroupNames"
        },
        recomBy: {
            column: "publication_recomby",
            title: "Recomby"
        },
        status: {
            column: "publication_status",
            title: "Status"
        },
        insertDate: {
            column: "insert_date",
            title: "Insert Date"
        },
        insertBy: {
            column: "insert_by",
            title: "Insert By"
        },
        updateDate: {
            column: "update_date",
            title: "Update Date"
        },
        updateBy: {
            column: "update_by",
            title: "Update By"
        },
        comeFrom: {
            column: "come_from",
            title: "Come From"
        },
        rFile: {
            column: "publication_rfile",
            title: "Rfile"
        },
        rDocFileExt: {
            column: "rDocFileExt",
            title: "rDocFileExt",
        },
        summary: {
            column: "summary",
            title: "Summary",
        },
    },
    [Modules.Documents]: {
        recordId: {
            column: "document_id",
            title: "recordId"
        },
        companyId: {
            column: "company_id",
            title: "Company Id"
        },
        memberId: {
            column: "member_id",
            title: "Member Id"
        },
        memberUser: {
            column: "member_user",
            title: "Member User"
        },
        folderId: {
            column: "folder_id",
            title: "Folder Name"
        },
        folderName: {
            column: "folder_name",
            title: "Folder Name"
        },
        title: {
            column: "document_title",
            title: "Title",
            titleAlt: "Document Title"
        },
        author: {
            column: "document_author",
            title: "Author(s)",
            titleAlt: "Author"
        },
        date: {
            column: "document_date",
            title: "Date",
            titleAlt: "Document Date"
        },
        url: {
            column: "document_url",
            title: "Link",
            titleAlt: 'Document URL'
        },
        file: {
            column: "document_file",
            title: "File"
        },
        fileExist: {
            column: "fileExist",
            title: "fileExist"
        },
        docFileExt: {
            column: "docFileExt",
            title: "docFileExt",
        },
        desc: {
            column: "document_desc",
            title: "Description"
        },
        notificationTo: {
            column: "notification_to",
            title: "Notification To"
        },
        recomBy: {
            column: "document_recomby",
            title: "Recomby"
        },
        status: {
            column: "document_status",
            title: "Status"
        },
        insertDate: {
            column: "insert_date",
            title: "Insert Date"
        },
        insertBy: {
            column: "insert_by",
            title: "Insert By"
        },
        updateDate: {
            column: "update_date",
            title: "Update Date"
        },
        updateBy: {
            column: "update_by",
            title: "Update By"
        },
        rFile: {
            column: "document_rfile",
            title: "File"
        },
        rDocFileExt: {
            column: "rDocFileExt",
            title: "rDocFileExt"
        },
        docFileUrl: {
            column: "docFileUrl",
            title: "docFileUrl"
        },
        summary: {
            column: "summary",
            title: "summary"
        },
        participantDisplayType: {
            column: "participantDisplayType",
            title: "participantDisplayType"
        },
        participantNames: {
            column: "meeting_participants",
            title: "Participants"
        },
        participantGroupNames: {
            column: "participantGroupNames",
            title: "participantGroupNames"
        },
        participantNamesSelectedOnly: {
            column: "participantNamesSelectedOnly",
            title: "Notification receivers"
        },
    },
    [Modules.CaseStudy]: {
        recordId: {
            column: "casestudy_id",
            title: "recordId"
        },
        companyId: {
            column: "company_id",
            title: "Company Id"
        },
        memberId: {
            column: "member_id",
            title: "Member Id"
        },
        memberUser: {
            column: "member_user",
            title: "Member User"
        },
        title: {
            column: "casestudy_title",
            title: "Title",
            titleAlt: 'Case Study Title'
        },
        date: {
            column: "casestudy_date",
            title: "Date",
            titleAlt: 'Case Study Date'
        },
        author: {
            column: "casestudy_createdby",
            // title: "Createdby",
            title: "Created By",
            titleAlt: "Author(s)"
        },
        url: {
            column: "casestudy_url",
            title: "Url",
            titleAlt: "Link",
            titleAlt2: "Reference",
            titleAlt3: 'Case Study URL'
        },
        file: {
            column: "casestudy_file",
            title: "File"
        },
        docFileExt: {
            column: "docFileExt",
            title: "docFileExt",
        },
        desc: {
            column: "casestudy_desc",
            title: "Description"
        },
        notificationTo: {
            column: "notification_to",
            title: "Notification To"
        },
        recomBy: {
            column: "casestudy_recomby",
            title: "Recomby"
        },
        status: {
            column: "casestudy_status",
            title: "Status"
        },
        insertDate: {
            column: "insert_date",
            title: "Insert Date"
        },
        insertBy: {
            column: "insert_by",
            title: "Insert By"
        },
        updateDate: {
            column: "update_date",
            title: "Update Date"
        },
        updateBy: {
            column: "update_by",
            title: "Update By"
        },
        comeFrom: {
            column: "come_from",
            title: "Come From"
        },
        rFile: {
            column: "casestudy_rfile",
            title: "Rfile"
        },
        rDocFileExt: {
            column: "rDocFileExt",
            title: "rDocFileExt",
        },
        summary: {
            column: "summary",
            title: "Summary",
        },
        participantDisplayType: {
            column: "participantDisplayType",
            title: "participantDisplayType"
        },
        participantNames: {
            column: "meeting_participants",
            title: "Participants"
        },
        participantGroupNames: {
            column: "participantGroupNames",
            title: "participantGroupNames"
        },
        participantNamesSelectedOnly: {
            column: "participantNamesSelectedOnly",
            title: "Notification receivers"
        },
    },
    [Modules.UsefulLinks]: {
        recordId: {
            column: "usefullink_id",
            title: "recordId"
        },
        companyId: {
            column: "company_id",
            title: "Company Id"
        },
        memberId: {
            column: "member_id",
            title: "Member Id"
        },
        memberUser: {
            column: "member_user",
            title: "Member User"
        },
        title: {
            column: "usefullink_title",
            title: "Title"
        },
        date: {
            column: "usefullink_date",
            title: "Date"
        },
        url: {
            column: "usefullink_url",
            title: "Url",
            titleAlt: "Link",
            titleAlt2: 'Useful Link'
        },
        desc: {
            column: "usefullink_desc",
            title: "Description",
        },
        notificationTo: {
            column: "notification_to",
            title: "Notification To"
        },
        recomBy: {
            column: "usefullink_recomby",
            title: "Recomby"
        },
        status: {
            column: "usefullink_status",
            title: "Status"
        },
        insertDate: {
            column: "insert_date",
            title: "Insert Date"
        },
        insertBy: {
            column: "insert_by",
            title: "Insert By"
        },
        updateDate: {
            column: "update_date",
            title: "Update Date"
        },
        updateBy: {
            column: "update_by",
            title: "Update By"
        },
        summary: {
            column: "summary",
            title: "Summary",
        },
        participantDisplayType: {
            column: "participantDisplayType",
            title: "participantDisplayType"
        },
        participantNamesSelectedOnly: {
            column: "participantNamesSelectedOnly",
            title: "Notification receivers"
        },
        participantNames: {
            column: "meeting_participants",
            title: "Participants"
        },
        participantGroupNames: {
            column: "participantGroupNames",
            title: "participantGroupNames"
        },
    },
    [Modules.Images]: {
        recordId: {
            column: "image_id",
            title: "recordId"
        },
        companyId: {
            column: "company_id",
            title: "Company Id"
        },
        memberId: {
            column: "member_id",
            title: "Member Id"
        },
        memberUser: {
            column: "member_user",
            title: "Member User"
        },
        albumId: {
            column: "album_id",
            title: "albumId"
        },
        albumName: {
            column: "album_name",
            title: "Album Name",
            titleAlt: "Album",
        },
        albumDesc: {
            column: "album_desc",
            title: "Album Description",
            titleAlt: "Description",
        },
        title: {
            column: "image_title",
            title: "Title",
            titleAlt: "Image",
        },
        thumbnail: {
            column: "image_thumb",
            title: "Thumbnail"
        },
        isImageLarge: {
            column: "image_large",
            title: "Large"
        },
        rFile: {
            column: "image_rfile",
            title: "Rfile"
        },
        rDocFileExt: {
            column: "rDocFileExt",
            title: "rDocFileExt",
        },
        desc: {
            column: "image_desc",
            title: "Description"
        },
        notificationTo: {
            column: "notification_to",
            title: "Notification To"
        },
        participantDisplayType: {
            column: "participantDisplayType",
            title: "participantDisplayType"
        },
        participantNames: {
            column: "participants",
            title: "participants"
        },
        participantNamesSelectedOnly: {
            column: "participantNamesSelectedOnly",
            title: "Notification receivers"
        },
        participantGroupNames: {
            column: "participantGroupNames",
            title: "participantGroupNames"
        },
        recomBy: {
            column: "image_recomby",
            title: "Recomby"
        },
        status: {
            column: "image_status",
            title: "Status"
        },
        albumStatus: {
            column: "album_status",
            title: "album_status"
        },
        insertDate: {
            column: "insert_date",
            title: "Insert Date"
        },
        insertBy: {
            column: "insert_by",
            title: "Insert By"
        },
        updateDate: {
            column: "update_date",
            title: "Update Date"
        },
        updateBy: {
            column: "update_by",
            title: "Update By"
        },
        imageList: {
            column: "imageList",
            title: "Images",
        },
        fileExt: {
            column: "fileExt",
            title: "fileExt",
        },
        rFileExt: {
            column: "rFileExt",
            title: "rFileExt",
        },
    },
    [Modules.Videos]: {
        recordId: {
            column: "video_id",
            title: "recordId"
        },
        companyId: {
            column: "company_id",
            title: "Company Id"
        },
        memberId: {
            column: "member_id",
            title: "Member Id"
        },
        memberUser: {
            column: "member_user",
            title: "Member User"
        },
        title: {
            column: "video_title",
            title: "Title"
        },
        url: {
            column: "video_url",
            title: "Url",
            titleAlt: "Video code (Copy url-code from browser's address bar & paste here, i.e: gQlMMD8auMs)",
            titleAlt2: "YouTube-video code",
            titleAlt3: "Paste this video link here",
        },
        desc: {
            column: "video_desc",
            title: "Description"
        },
        notificationTo: {
            column: "notification_to",
            title: "Notification To"
        },
        participantDisplayType: {
            column: "participantDisplayType",
            title: "participantDisplayType"
        },
        participantNames: {
            column: "participants",
            title: "participants"
        },
        participantNamesSelectedOnly: {
            column: "participantNamesSelectedOnly",
            title: "Notification receivers"
        },
        participantGroupNames: {
            column: "participantGroupNames",
            title: "participantGroupNames"
        },
        recomBy: {
            column: "video_recomby",
            title: "Recomby"
        },
        status: {
            column: "video_status",
            title: "Status"
        },
        insertDate: {
            column: "insert_date",
            title: "Insert Date",
            titleAlt: "Date",
        },
        insertBy: {
            column: "insert_by",
            title: "Insert By"
        },
        updateDate: {
            column: "update_date",
            title: "Update Date"
        },
        updateBy: {
            column: "update_by",
            title: "Update By"
        }
    },

    [Modules.RecommendActivity]: {
        recordId: {
            column: "id",
            title: "recordId"
        },
        companyId: {
            column: "company_id",
            title: "Company Id"
        },
        memberId: {
            column: "member_id",
            title: "Member Id"
        },
        memberUser: {
            column: "member_user",
            title: "Member User"
        },
        category: {
            column: "category",
            title: "Category",
            titleAlt: "Category",
        },
        topic: {
            column: "topic",
            title: "Topic",
        },
        desc: {
            column: "act_desc",
            title: "Topic Description",
        },
        file: {
            column: "file",
            title: "Any supporting Document"
        },
        docFileExt: {
            column: "docFileExt",
            title: "docFileExt",
        },
        date: {
            column: "act_date",
            title: "Date",
            titleAlt: "Proposed Date & Time",
        },
        insertDate: {
            column: "insert_date",
            title: "Insert Date",
        },
        status: {
            column: "status",
            title: "status",
        },
        insertBy: {
            column: "insert_by",
            title: "Insert By",
        },
        categoryId: {
            column: "categoryId",
            title: "Category Name"
        },
    },
    [Modules.RecommendPeer]: {
        recordId: {
            column: "id",
            title: "recordId"
        },
        companyId: {
            column: "company_id",
            title: "Company Id"
        },
        memberId: {
            column: "member_id",
            title: "Member Id"
        },
        memberUser: {
            column: "member_user",
            title: "Member User"
        },
        name: {
            column: "peer_name",
            title: "Peer's Name",
        },
        phone: {
            column: "phone",
            title: "Peer's Phone No.",
        },
        email: {
            column: "email",
            title: "Peer's Email Id",
        },
        city: {
            column: "city",
            title: "Peer's City",
        },
        comment: {
            column: "comment",
            title: "Comment",
        },
        status: {
            column: "status",
            title: "status",
        },
        insertDate: {
            column: "insert_date",
            title: "Insert Date",
        },
        insertBy: {
            column: "insert_by",
            title: "Insert By",
        },
    },
    [Modules.News]: {
        recordId: {
            column: "news_id",
            title: "recordId"
        },
        companyId: {
            column: "company_id",
            title: "Company Id"
        },
        memberId: {
            column: "member_id",
            title: "Member Id"
        },
        memberUser: {
            column: "member_user",
            title: "Member User"
        },
        title: {
            column: "news_title",
            title: "News Title"
        },
        date: {
            column: "news_date",
            title: "News Date"
        },
        link: {
            column: "news_link",
            title: "News Link"
        },
        desc: {
            column: "news_desc",
            title: "News Description",
        },
        notificationTo: {
            column: "notification_to",
            title: "Notification To"
        },
        participantDisplayType: {
            column: "participantDisplayType",
            title: "participantDisplayType"
        },
        participantNames: {
            column: "participants",
            title: "participants"
        },
        participantNamesSelectedOnly: {
            column: "participantNamesSelectedOnly",
            title: "Notification receivers"
        },
        participantGroupNames: {
            column: "participantGroupNames",
            title: "participantGroupNames"
        },
        recomBy: {
            column: "news_recomby",
            title: "News Recomby"
        },
        status: {
            column: "news_status",
            title: "News Status"
        },
        insertDate: {
            column: "insert_date",
            title: "Insert Date"
        },
        insertBy: {
            column: "insert_by",
            title: "Insert By"
        },
        updateDate: {
            column: "update_date",
            title: "Update Date"
        },
        updateBy: {
            column: "update_by",
            title: "Update By"
        },
    },

    [Modules.Messages]: {
        // recordIdx: {
        //     column: "recordId",
        //     title: "recordId",
        // },
        // image: {
        //     column: "image",
        //     title: "Image",
        // },
        // from: {
        //     column: "from",
        //     title: "From",
        // },
        // subject: {
        //     column: "subject",
        //     title: "Subject",
        // },
        // date: {
        //     column: "date",
        //     title: "Date",
        // },
        sent: {
            column: "sent",
            title: "Sent",
        },
        received: {
            column: "received",
            title: "Received",
        },

        //some column-names depend on the join in db_handler.msg__mainPage_fetch_recordList function query
        recordId: {
            column: 'message_id',
            title: 'recordId'
        },
        replyId: {
            column: 'reply_id',
            title: 'Reply Id'
        },
        replyName: {
            column: 'reply_name',
            title: 'Reply Name'
        },
        fromId: {
            column: 'message_from',
            title: 'From'
        },
        fromName: {
            column: 'message_from_name',
            title: 'From',
            titleAlt: 'From Name',
        },
        fromEmail: {
            column: 'from_person_email',
            title: 'From Email',
            titleAlt: 'From Email',
        },
        fromEmailAlt: {
            column: 'from_person_email_alt',
            title: 'From Email Alt',
            titleAlt: 'From Email Alt',
        },
        fromImage: {
            column: 'from_person_image',
            title: 'From Person Image'
        },
        toId: {
            column: 'message_to',
            title: 'To'
        },
        toName: {
            column: 'message_to_name',
            title: 'To',
            titleAlt: 'To Name',
        },
        subject: {
            column: 'message_subject',
            title: 'Subject'
        },
        body: {
            column: 'message_body',
            title: 'Body'
        },
        status: {
            column: 'message_status',
            title: 'Status'
        },
        readStatus: {
            column: 'read_status',
            title: 'Read Status'
        },
        insertDate: {
            column: 'insert_date',
            title: 'Date',
            titleAlt: 'Insert Date',
        },
        insertBy: {
            column: 'insert_by',
            title: 'Insert By'
        },
        updateDate: {
            column: 'update_date',
            title: 'Update Date'
        },
        updateBy: {
            column: 'update_by',
            title: 'Update By'
        },

        msgBox_Subject: {
            column: "msgBox_Subject",
            title: "Subject"
        },
        msgBox_Message: {
            column: "msgBox_Message",
            title: "Message"
        },
        recipients: {
            column: "Recipients",
            title: "Recipients"
        },
        recipientsSelectedOnly: {
            column: "recipientsSelectedOnly",
            title: "Recipients"
        },
        thread: {
            column: "thread",
            title: "thread"
        },
    },
    [Modules.PeerProfiles]: {
        //  "recordId": 0,
        //             "image": "https://randomuser.me/api/portraits/men/0.jpg",
        //             "name": "Dr. Jason Johnson",
        //             "bio": "MediHealth Clinic, New York"
        recordId: {
            column: "recordId",
            title: "recordId",
        },
        image: {
            column: "image",
            title: "Image",
        },
        role: {
            column: "role",
            title: "Role",
        },
        name: {
            column: "name",
            title: "Name",
        },
        bio: {
            column: "bio",
            title: "Bio",
        },
    },
    [Modules.MyParticipations]: {
        recordId: {
            column: "recordId",
            title: "recordId",
        },
        presenter: {
            column: "presenter",
            title: "Presenter",
        },
        outline: {
            outline: "outline",
            title: "Outline",
        },
        date: {
            outline: "date",
            title: "Date",
        },

    },
    [Modules.Survey_ViewQs]: {
        recordId: {
            column: "squestion_id",
            title: "recordId"
        },
        surveyId: {
            column: "survey_id",
            title: "Survey Id"
        },
        companyId: {
            column: "company_id",
            title: "Company Id"
        },
        memberId: {
            column: "member_id",
            title: "Member Id"
        },
        question: {
            column: "survey_question",
            title: "Survey Question"
        },
        answerType: {
            column: "answer_type",
            title: "Answer Type"
        },
        answerTypeName: {
            column: "answerTypeName",
            title: "Answer Type Name"
        },
        image: {
            column: "question_image",
            title: "Image"
        },
        link: {
            column: "question_vlink",
            title: "Link"
        },
        rangeStart: {
            column: "range_start",
            title: "Range Start"
        },
        rangeEnd: {
            column: "range_end",
            title: "Range End"
        },
        dateTime: {
            column: "date_time",
            title: "Date Time"
        },
        rank: {
            column: "squestion_rank",
            title: "Squestion Rank"
        },
        status: {
            column: "squestion_status",
            title: "Squestion Status"
        },
        insertDate: {
            column: "insert_date",
            title: "Insert Date"
        },
        insertBy: {
            column: "insert_by",
            title: "Insert By"
        },
        updateDate: {
            column: "update_date",
            title: "Update Date"
        },
        updateBy: {
            column: "update_by",
            title: "Update By"
        },

        // answer: {
        //     //based on join-query, at: db_handler.survey__addEditQsPage_fetch_editFormData()
        //     column: "answer",
        //     title: "answer"
        // },
        // qIndex: {
        //     //based on join-query, at: db_handler.survey__addEditQsPage_fetch_editFormData()
        //     column: "qIndex",
        //     title: "qIndex"
        // },

        imageFileExt: {
            column: "imageFileExt",
            title: "imageFileExt"
        },
        showImage: {
            column: "showImage",
            title: "showImage"
        },
        showLink: {
            column: "showLink",
            title: "showLink"
        },
        answerType_cb_radio_InputValue: {
            column: "answerType_cb_radio_InputValue",
            title: "answerType_cb_radio_InputValue"
        },
        answerType_multipleChoice: {
            column: "answerType_multipleChoice",
            title: "Multiple choice options"
        },
        answerType_checkbox: {
            column: "answerType_checkbox",
            title: "Checkbox options"
        },
        answerType_dateTimeType: {
            column: "answerType_dateTimeType",
            title: "Date-time"
        },
        answerType_Likert_LikertData: {
            column: "answerType_Likert_LikertData",
            title: "Likert/Grid Options"
        },
        answerType_AnsValue: {
            column: "answerType_AnsValue",
            title: "answerType_AnsValue"
        },
        answerType_AnsValue2: {
            column: "answerType_AnsValue2",
            title: "answerType_AnsValue2"
        },
        answerType_AnsValue_Index: {
            column: "answerType_AnsValue_Index",
            title: "answerType_AnsValue_Index"
        },
        answerType_AnsValue2_Index: {
            column: "answerType_AnsValue2_Index",
            title: "answerType_AnsValue2_Index"
        },
    },
    [Modules.LoginBypass]: {
        //id, member_id, company_id, token, token_alias, share_limit, for_anyone, redirect_url, expire_at, status, ip_address, insert_date, insert_by, update_date, update_by
        recordId: {
            column: 'id',
            title: 'recordId'
        },
        memberId: {
            column: 'member_id',
            title: 'Member Id'
        },
        companyId: {
            column: 'company_id',
            title: 'Company Id'
        },
        token: {
            column: 'token',
            title: 'Token'
        },
        tokenAlias: {
            column: 'token_alias',
            title: 'Token Alias'
        },
        shareLimit: {
            column: 'share_limit',
            title: 'Share Limit'
        },
        forAnyone: {
            //This field will require a guest-user in the database-table (Discuss with Sir)
            column: 'for_anyone',
            title: 'For Anyone'
        },
        usedCount: {
            column: 'used_count',
            title: 'Used Count'
        },
        expireAt: {
            column: 'expire_at',
            title: 'Expire At'
        },
        expireAt_JWT: {
            column: 'expire_at_jwt',
            title: 'Expire At - JWT'
        },
        membersSelectOnly: {
            column: 'membersSelectOnly',
            title: 'membersSelectOnly'
        },
        redirectUrl: {
            column: 'redirect_url',
            title: 'Redirect Url'
        },
        ipAddress: {
            column: 'ip_address',
            title: 'IP Address'
        },
        status: {
            column: 'status',
            title: 'Status'
        },
        insertDate: {
            column: 'insert_date',
            title: 'Insert Date'
        },
        insertBy: {
            column: 'insert_by',
            title: 'Insert By'
        },
        updateDate: {
            column: 'update_date',
            title: 'Update Date'
        },
        updateBy: {
            column: 'update_by',
            title: 'Update By'
        }
    },
    [Modules.EventAlerts]: {
        recordId: {
            column: 'id',
            title: 'recordId'
        },
        memberId: {
            column: 'member_id',
            title: 'Member Id'
        },
        companyId: {
            column: 'company_id',
            title: 'Company Id'
        },
        eventType: {
            column: 'event_type',
            title: 'Event Type'
        },
        eventId: {
            column: 'event_id',
            title: 'Event Id'
        },
        eventTitle: {
            column: 'event_title',
            title: 'Event Title'
        },
        eventDate: {
            column: 'event_date',
            title: 'Event Date'
        },
        eventReminderType: {
            column: 'event_reminder_type',
            title: 'Event Reminder Type'
        },
        eventReminderDate: {
            column: 'event_reminder_date',
            title: 'Event Reminder Date'
        },
        participants: {
            column: 'participants',
            title: 'Participants'
        },
        sendSms: {
            column: 'send_sms',
            title: 'Send Sms'
        },
        sendEmail: {
            column: 'send_email',
            title: 'Send Email'
        },
        lastSent: {
            column: 'last_sent',
            title: 'Last Sent'
        },
        sentCount: {
            column: 'sent_count',
            title: 'Sent Count'
        },
        status: {
            column: 'status',
            title: 'Status'
        },
        insertDate: {
            column: 'insert_date',
            title: 'Insert Date'
        },
        insertBy: {
            column: 'insert_by',
            title: 'Insert By'
        },
        updateDate: {
            column: 'update_date',
            title: 'Update Date'
        },
        updateBy: {
            column: 'update_by',
            title: 'Update By'
        }
    },
    [Modules.Help]: {},
    [Modules.AllModules]: {
        id: {
            column: 'id',
            title: 'Id'
        },
        name: {
            column: 'name',
            title: 'Name'
        },
        nameAlt: {
            //Depends on the JOIN at db_handler.perms_fetchAllocatedModules
            column: 'nameAlt',
            title: 'Alternative Name'
        },
        description: {
            column: 'description',
            title: 'Description'
        },
        status: {
            column: 'status',
            title: 'Status'
        },
        insertDate: {
            column: 'insert_date',
            title: 'Insert Date'
        },
        insertBy: {
            column: 'insert_by',
            title: 'Insert By'
        },
        updateDate: {
            column: 'update_date',
            title: 'Update Date'
        },
        updateBy: {
            column: 'update_by',
            title: 'Update By'
        }
    },
    [Modules.AllocatedModules]: {
        id: {
            column: 'id',
            title: 'Id'
        },
        moduleId: {
            column: 'module_id',
            title: 'Module Id'
        },
        companyId: {
            column: 'company_id',
            title: 'Company Id'
        },
        allocatedName: {
            column: 'allocated_name',
            title: 'Allocated Name'
        },
        show: {
            column: 'show',
            title: 'Show'
        },
        insertDate: {
            column: 'insert_date',
            title: 'Insert Date'
        },
        insertBy: {
            column: 'insert_by',
            title: 'Insert By'
        },
        updateDate: {
            column: 'update_date',
            title: 'Update Date'
        },
        updateBy: {
            column: 'update_by',
            title: 'Update By'
        }
    },
};

export const DashSearchModules = {
    res: {name: Modules.Resources, id: 'unlt4'},
    doc: {name: Modules.Documents, id: 'apxsd4'},
    wm: {name: Modules.WebMeeting, id: 'orl10n'},
    meetings: {name: Modules.Meetings, id: 'h0d61t'},
    df: {name: Modules.DiscussionForum, id: 'b0x5ga'},
    srv: {name: Modules.Survey, id: 'mkshd6sa'},
    pp: {name: Modules.PeerProfiles, id: 'ljs5gd'},
    msg: {name: Modules.Messages, id: 'l5stra4s'},
};

export const DashSearchTargets = {
    all: {name: 'All Fields', id: 'hy63ri0n'},
    title: {name: 'Title', id: 'at4ium'},
    desc: {name: 'Description', id: 't40n1l'},
    titleDesc: {name: 'Title & Description', id: 'atx3jd'},
};

export const SurveyQTypes = {
    textarea: {name: "Textarea", value: "Textarea"},
    paragraph: {name: "Paragraph", value: "Paragraph"},
    multipleChoice: {name: "Multiple Choice (to choose from many)", value: "Multiple Choice"},
    checkboxes: {name: "Checkboxes (to choose more than one)", value: "Checkboxes"},
    sliderRange: {name: "Slider Range (1,2,3...10)", value: "Slider Range"},
    dateTime: {name: "Date & Time", value: "Date and Time"},
    likert: {name: "Likert/Option Grid", value: "Likert"},
};

export const EventModules = {
    meeting: Modules.Meetings,
    wm: Modules.WebMeeting,
    survey: Modules.Survey,
    forum: Modules.DiscussionForum,
}
//--------------Backend-Frontend common fields end-------------------------------

export const Selectors = {
    DASH_TAB_CONTENT_WRAPPER_ID: 'DASH_TAB_CONTENT_WRAPPER_ID',
};

export const EventFormRepeatTypes = {
    //Do Not Repeat, Weekly, Monthly, Date
    doNotRepeat: "Do Not Repeat",
    weekly: "Weekly",
    monthly: "Monthly",
    date: "Date",
};
export const EventFormParticipantTypes = {
    membersOnly: "Show all members",
    groupsOnly: "Show all groups",
};
export const EventFormMemberType = {
    member: "Existing Member",
    notMember: "Not a Member",
};
export const ShowViewType = {
    PANEL: 'PANEL',
    DIALOG: 'DIALOG',
    DRAWER: 'DRAWER',
    PAGE: 'PAGE',
};
export const SurveyDateTimeTypes = {
    date: "Date Only",
    time: "Time Only",
    dateTime: "Date & Time",
};
export const ShareFeatureModules = [
    //Web-Meeting Details
    // Meeting Details
    // Publication Details
    // Document Details
    // Case Study Details
    // Forum Details
    // View Survey
    {module: Modules.WebMeeting, tag: 'Wm_InternalPage'},
    {module: Modules.Meetings, tag: 'Meeting_InternalPage'},
    {module: Modules.DiscussionForum, tag: 'Forum_InternalPage'},
    {module: Modules.Publication, tag: 'Pub_InternalPage'},
    {module: Modules.Documents, tag: 'Doc_InternalPage'},
    {module: Modules.CaseStudy, tag: 'CS_InternalPage'},
    {module: Modules.Survey, tag: 'Survey_ViewPage'},
];
export const EventTypes = {
    all: {id: 0, text: 'All'},
    // ongoing: {id: 1, text: 'Ongoing'},
    // today: {id: 2, text: 'Today'},
    // tomorrow: {id: 3, text: 'Tomorrow'},
    upcoming: {id: 4, text: 'Upcoming'},
    expired: {id: 5, text: 'Expired', textAlt: 'Ended', textAlt2: 'Completed'},
    //, variant: 'primary', variantAlt: 'primary'
};
export const ThemeTypes = {
    light: {id: 0, text: "Light", icon: 'bi bi-brightness-low', variant: 'primary'},
    dark: {id: 1, text: "Dark", icon: 'bi bi-moon', variant: 'dark'},
    // system:{id:2,text:"System"},
};
